<template>
  <div class="ml-md-n4 my-n1">
    <RouterLink
      :to="vacancyLink"
      class="body-2 text-decoration-none"
    >
      {{ vacancy.title }}
      <VTooltip bottom max-width="365">
        <template v-slot:activator="{ on }">
          <VIcon
            v-show="isLocked"
            size="13"
            color="grey"
            class="mt-n1 ml-2"
            v-on="on"
          >
            {{ mdiLock }}
          </VIcon>
        </template>
        <span>
          {{ $t('invitationTip') }}
        </span>
      </VTooltip>
    </RouterLink>
    <div class="caption text-no-wrap grey--text text--darken-1">
      <AppDateFormatted :value="vacancy.publishedFrom" />
    </div>
  </div>
</template>

<script>
import { mdiLock } from '@mdi/js';
import { vacancyVisibility } from '../../enums';
import AppDateFormatted from '../AppDateFormatted.vue';
import { isLocked } from '../Vacancy/functions';

export default {
  name: 'CompanyVacanciesTableRowTitle',
  components: { AppDateFormatted },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiLock,
      vacancyVisibility,
    };
  },
  computed: {
    isLocked() {
      return isLocked(this.vacancy);
    },
    vacancyLink() {
      if (this.$route?.query?.preview === 'true') {
        return {
          name: 'vacancy',
          params: { companyId: this.companyId, vacancyId: this.vacancy.id },
          query: { preview: 'true' },
        };
      }
      return {
        name: 'vacancy',
        params: { companyId: this.companyId, vacancyId: this.vacancy.id },
      };
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  invitationTip: Available by invitation only
  salary: Salary
</i18n>

<i18n locale="ru" lang="yaml">
  invitationTip: Пройти онлайн-собеседование на эту вакансию возможно только по приглашению работодателя.
  salary: з/п
</i18n>
